<ng-container *ngFor="let button of buttons">
  <button
    mat-icon-button
    class="btn-multicolor header-icon"
    [disabled]="button.disabled"
    (click)="onClick(button); $event.stopPropagation()"
  >
    <mat-icon *ngIf="button.icon" class="header-icon-img">{{ button.icon }}</mat-icon
    ><span class="header-icon-name">{{ button.value | translate }}</span>
  </button>
</ng-container>
